import React, {Component} from 'react';
import {cloneDeep, get} from 'lodash';
import classnames from 'classnames';

import PropTypes from 'prop-types';

// Actions
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {withLastLocation} from 'react-router-last-location';
import {push} from '../actions/router-actions';

// Radar UI components
import Form from '../components-core/form';
import Loading from '../components-core/loading';
import ReorderShelfList from '../components-core/reorder-shelf-list';

import * as shelfActions from '../actions/shelf-actions';

// PrimeReact styles
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

import searchHoc from './search-wrapper';

const servicesDataKey = 'loadSubShelves';

class ReorderShelves extends Component {
    state = {
        parentShelfId: this.props.match.params.parentshelfid, // eslint-disable-line react/destructuring-assignment
    };

    UNSAFE_componentWillUpdate(nextProps) {
        const {fetching, history} = this.props;
        const {error} = this.state;

        if (nextProps.error && error !== nextProps.error) {
            this.setState({error: nextProps.error});
        } else if (fetching && !nextProps.fetching) {
            this.setState({}, () => {
                history.goBack();
            });
        }
    }

    getSearchValues() {
        return get(this.props, 'searchData.ShelfDTO.subShelves', {});
    }

    getClass() {
        const {className} = this.props;

        return classnames(className, 'main-nav');
    }

    getSortOptionProps() {
        const {parentShelfId} = this.state;

        return {
            parentShelfId,
            shelvesData: this.getSearchValues(),
        };
    }

    cancelShelfOrder = () => {
        const {lastLocation} = this.props;

        if (lastLocation) {
            window.location.href = lastLocation.pathname;
        } else {
            window.location.href = '/';
        }
    };

    updateShelfOrder = reorderedShelves => {
        const {searchData, reorderShelves} = this.props;

        if (searchData) {
            const shelfObj = cloneDeep(searchData);

            shelfObj.ShelfDTO.subShelves = reorderedShelves;
            this.setState({error: null}, () => reorderShelves(shelfObj));
        }
    };

    render() {
        const {fetching, fetched} = this.props;

        return (
            <Form>
                <br />
                <ReorderShelfList
                    {...this.getSortOptionProps()}
                    cancelShelfOrder={this.cancelShelfOrder}
                    fetched={fetched}
                    id="shelfreorderlist"
                    name="shelfreorderlist"
                    updateShelfOrder={this.updateShelfOrder}
                />

                <Loading loading={fetching} />
            </Form>
        );
    }
}

ReorderShelves.propTypes = {
    className: PropTypes.object,
    error: PropTypes.string,
    fetched: PropTypes.bool,
    fetching: PropTypes.bool,
    history: PropTypes.object,
    lastLocation: PropTypes.object,
    mapping: PropTypes.bool,
    match: PropTypes.object,
    push: PropTypes.func.isRequired,
    reorderShelves: PropTypes.func.isRequired,
    routerParams: PropTypes.object,
    searchData: PropTypes.array.isRequired,
    submitted: PropTypes.bool,
};

function mapStateToProps(state) {
    return {...state.updateShelf};
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({...shelfActions, push}, dispatch);
}

export default withLastLocation(
    searchHoc(connect(mapStateToProps, mapDispatchToProps)(ReorderShelves), servicesDataKey)
);
